import _ from 'underscore';

export const multimediaModel = (data) => {
  const headlines = _.map(data.Headlines, headline => ({
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: headline.Text,
    },
    PinnedField: headline.PinnedFieldTypeString,
  }));

  const longHeadlines = _.map(data.LongHeadlines, longHeadline => ({
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: longHeadline.Text,
    },
    PinnedField: longHeadline.PinnedFieldTypeString,
  }));

  const descriptions = _.map(data.Descriptions, description => ({
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: description.Text,
    },
    PinnedField: description.PinnedFieldTypeString,
  }));

  const images = [];
  _.each(data.Images, (image) => {
    _.each(image.AssociationMetadata, (metadata) => {
      images.push({
        Asset: {
          '@odata.type': '#Model.ImageAsset',
          SubType: metadata.SubType,
          Name: null,
          AssetType: 'Empty',
          Text: null,
          CropX: metadata.CropX,
          CropY: metadata.CropY,
          CropHeight: metadata.CropWidth,
          CropWidth: metadata.CropHeight,
          ImageUrl: image.ImageUrl,
          Id: image.ImageAssetIdString,
          ImageHeight: image.ImageHeight,
          ImageWidth: image.ImageWidth,
          IsRecommendedImage: true,
          DisableEdit: true,
        },
        PinnedField: image.PinnedFieldTypeString,
      });
    });
  });

  return {
    FinalUrls: [
      data.FinalUrl,
    ],
    MobileFinalUrls: [
      data.MobileFinalUrl,
    ],
    TrackingUrlTemplate: null,
    UrlCustomParameters: [],
    Type: 'Responsive',
    Id: data.OpportunityId,
    BusinessName: data.BusinessName,
    Headlines: headlines,
    LongHeadlines: longHeadlines,
    Descriptions: descriptions,
    Images: images,
    CallToAction: data.CallToAction,
    CallToActionLanguage: data.CallToActionLanguage,
    FinalUrlSuffix: data.FinalUrlSuffix,
    ImpressionTrackingUrls: [],
    LandscapeImageMediaId: null,
    SquareImageMediaId: null,
    LandscapeLogoMediaId: null,
    SquareLogoMediaId: null,
  };
};

export const getImageFeatureMaskMap = (data) => {
  const map = new Map();
  _.each(data.Images, (image) => {
    const key = image.ImageAssetIdString || image.ImageUrl;
    if (!_.isUndefined(key) && image.FeatureMask !== '') {
      map.set(key, image.FeatureMask);
    }
  });
  return map;
};
